<script setup lang="ts">
const props = defineProps<{
  item: {
    title: string,
    desc: string,
    icon: string
  },
}>();
</script>

<template>
  <div
    class="card max-w-[350px] h-[275px] shadow-primary-xs hover:shadow-primary-s relative text-center flex-center flex-col gap-3
      rounded-3xl pt-[30px] pb-5 px-6 overflow-hidden z-1 bg-white cursor-default"
  >
    <h3>{{ props.item.title }}</h3>
    <p class="text-gray-500 text-body2">{{ props.item.desc }}</p>
    <div class="mt-auto p-4 rounded-full border border-secondary-500 bg-white flex-center">
      <Icon :name="props.item.icon" class="text-secondary-500" size="40" />
    </div>
  </div>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.card::before {
  @apply
  content-[''] absolute w-full h-15 bottom-0 left-0 bg-primary-50
  z-[-1] transition-all duration-500
}
.card:hover::before {
  @apply
  h-full
}
</style>
